import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import { useT } from '../lib/i18n';

export function StakingView() {
  const sessions = useSelector((s: RootState) => s.sessions.list);
  const { t } = useT();
  const stakedSessions = sessions.filter(s => s.staking.isStaked);

  const backers: Record<string, { name: string; sessions: typeof stakedSessions; totalGross: number; totalNet: number; totalBacker: number; myPercent: number }> = {};
  for (const s of stakedSessions) {
    const name = s.staking.stakerName || t('staking.unnamed');
    if (!backers[name]) backers[name] = { name, sessions: [], totalGross: 0, totalNet: 0, totalBacker: 0, myPercent: s.staking.myPercent };
    backers[name].sessions.push(s);
    backers[name].totalGross   += s.grossProfit;
    backers[name].totalNet     += s.netProfit;
    backers[name].totalBacker  += s.grossProfit - s.netProfit;
  }

  const backerList         = Object.values(backers);
  const totalStakedGross   = stakedSessions.reduce((a, s) => a + s.grossProfit, 0);
  const totalStakedNet     = stakedSessions.reduce((a, s) => a + s.netProfit, 0);
  const totalBackerShare   = totalStakedGross - totalStakedNet;

  if (stakedSessions.length === 0) {
    return (
      <div className="staking-view">
        <h2 className="form-title">{t('staking.title')}</h2>
        <div className="empty-state small"><p>{t('staking.noStaked')}</p></div>
      </div>
    );
  }

  return (
    <div className="staking-view">
      <h2 className="form-title">{t('staking.title')}</h2>

      <div className="staking-overview">
        <div className="stk-stat"><span>{t('staking.stakedSessions')}</span><span>{stakedSessions.length}</span></div>
        <div className="stk-stat"><span>{t('staking.grossProfit')}</span><span className={totalStakedGross >= 0 ? 'pos' : 'neg'}>{totalStakedGross >= 0 ? '+' : ''}${totalStakedGross.toFixed(2)}</span></div>
        <div className="stk-stat"><span>{t('staking.myProfit')}</span><span className={totalStakedNet >= 0 ? 'pos' : 'neg'}>{totalStakedNet >= 0 ? '+' : ''}${totalStakedNet.toFixed(2)}</span></div>
        <div className="stk-stat"><span>{t('staking.backerShare')}</span><span className={totalBackerShare >= 0 ? 'pos' : 'neg'}>{totalBackerShare >= 0 ? '+' : ''}${totalBackerShare.toFixed(2)}</span></div>
      </div>

      <div className="panel-title" style={{ marginTop: '1.5rem' }}>{t('staking.byBacker')}</div>
      {backerList.map(b => (
        <div key={b.name} className="panel backer-card">
          <div className="backer-header">
            <span className="backer-name">{b.name}</span>
            <span className="backer-split">{b.myPercent}% / {100 - b.myPercent}%</span>
          </div>
          <div className="backer-stats">
            <div className="bstk"><span>{t('staking.sessions')}</span><span>{b.sessions.length}</span></div>
            <div className="bstk"><span>{t('staking.gross')}</span><span className={b.totalGross >= 0 ? 'pos' : 'neg'}>{b.totalGross >= 0 ? '+' : ''}${b.totalGross.toFixed(2)}</span></div>
            <div className="bstk"><span>{t('staking.myPart')}</span><span className={b.totalNet >= 0 ? 'pos' : 'neg'}>{b.totalNet >= 0 ? '+' : ''}${b.totalNet.toFixed(2)}</span></div>
            <div className="bstk"><span>{t('staking.theirPart')}</span><span className={b.totalBacker >= 0 ? 'pos' : 'neg'}>{b.totalBacker >= 0 ? '+' : ''}${b.totalBacker.toFixed(2)}</span></div>
          </div>
          <div className="backer-sessions">
            {b.sessions.map(s => (
              <div key={s.id} className={`bsess-row ${s.grossProfit >= 0 ? 'win' : 'loss'}`}>
                <span>{s.date}</span>
                <span>${s.totalInvested.toFixed(2)}</span>
                <span className={s.grossProfit >= 0 ? 'pos' : 'neg'}>{t('staking.gross')}: {s.grossProfit >= 0 ? '+' : ''}${s.grossProfit.toFixed(2)}</span>
                <span className={s.netProfit >= 0 ? 'pos' : 'neg'}>{t('staking.myPart')}: {s.netProfit >= 0 ? '+' : ''}${s.netProfit.toFixed(2)}</span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
